<template>
  <div class="edu-welcome-modal" ref="modalContainerRef">
    <div class="modal-content">
      <div class="modal-title">
        <img class="logo" src="@/assets/images/edu/img_logo.webp" alt="logo" />
        <span class="title">欢迎你来到造好物！</span>
      </div>
      <div class="modal-body">
        <div class="text1" v-if="allHistoryCount > 0">
          哇！你真棒，你在第一节课堂上生成了
          <span class="num">{{ allHistoryCount }}</span>
          个作品！
        </div>
        <div ref="textRef" class="text2"></div>
      </div>
      <div class="modal-footer">
        <div class="tips" ref="tipsRef"></div>
        <AppButton @clickEvent="handleClick">我准备好了，立即探索</AppButton>
      </div>

      <div class="icon-close" @click="props.onClose">
        <span class="hitems-close"></span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import AppButton from '@/components/AppButton/index.vue'
  import { onMounted, onBeforeUnmount, ref } from 'vue'
  import emitter, { EventBusKey } from '@/utils/eventBusMitt'
  import { useRouter } from 'vue-router'
  import api from './api'

  defineOptions({
    name: 'EduWelcomModal'
  })

  const router = useRouter()
  const props = defineProps<{
    onClose: () => void
  }>()

  const textRef = ref<HTMLElement>()
  const tipsRef = ref<HTMLElement>()
  const allHistoryCount = ref(0)
  const modalContainerRef = ref<HTMLElement>()

  onMounted(() => {
    if (textRef.value) {
      textRef.value.innerText =
        '你已经是个人工智能小专家啦，\n接下来继续在造好物平台 施展更多创意吧！'
    }

    if (tipsRef.value) {
      tipsRef.value.innerText =
        '小提示：稍后，你可以在页面右上角点击“个人头像”，\n修改一个专属于你的账号密码哦！'
    }

    if (modalContainerRef.value) {
      modalContainerRef.value.addEventListener('wheel', handleWheel, { passive: false })
    }

    getHistoryCount()
  })

  onBeforeUnmount(() => {
    if (modalContainerRef.value) {
      modalContainerRef.value.removeEventListener('wheel', handleWheel)
    }
  })

  const handleWheel = (e: WheelEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleClick = () => {
    props.onClose()
    if (allHistoryCount.value > 0) {
      emitter.emit(EventBusKey.showEduHistoryModal)
    } else {
      router.push('/account')
    }
  }

  const getHistoryCount = async () => {
    const res = await api.getHistoryCount()
    if (res.code === 200) {
      allHistoryCount.value = res.data.image + res.data.model
      if (textRef.value) {
        if (allHistoryCount.value > 0) {
          textRef.value.innerText =
            '你已经是个人工智能小专家啦，\n接下来继续在造好物平台 施展更多创意吧！'
        } else {
          textRef.value.innerText =
            '经过你在课堂的练习，你一定掌握了不少AI创作的小诀窍！\n接下来继续在造好物平台 施展更多创意吧！'
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
